// Parcely controls shipping prices. Legacy hard-coded label overrides are retired.
/* Distinguish verified cart additions, cart views and checkout clicks. */
(function () {
  function track(name) {
    try {
      if (typeof window.clarity === 'function') window.clarity('event', name);
    } catch (error) { /* Analytics must not interrupt shopping. */ }
  }
  document.addEventListener('pa:cart-add-success', function () {
    track('pa_add_to_cart_success');
  });
  function cartView() {
    if (/(^|\/)cart\/?$/.test(window.location.pathname)) track('pa_cart_view');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cartView);
  else cartView();
  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest ? event.target.closest('button[name="checkout"], a[href="/checkout"]') : null;
    if (!target || target.disabled || target.getAttribute('aria-disabled') === 'true') return;
    var terms = document.getElementById('terms_conditions');
    if (terms && !terms.checked) return;
    track('pa_checkout_click');
  }, true);
})();
